/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        ////state modal
        //if ( $.cookie("product_redirect") == null ) {
          //$('#state-select').modal({
            //backdrop: 'static',
            //keyboard: false,
            //show: true
          //});
          //$("#state-select button").click(function(){
            //var button_val = $(this).val();
            //if (button_val === 'OR') {
              ////alert('Redirecting to Oregon...');
              //$.cookie("product_redirect", "OR", { expires: 7 });
              //$('#state-select').modal('hide');
            //} else {
              ////alert('Redirecting to Other Place');
              //$.cookie("product_redirect", "XX", { expires: 7 });
              //$('.notCA').removeClass('hidden');
              //$('#state-select').modal('hide');
            //}
          //});
        //} else if ($.cookie("product_redirect") === 'OR') {
          ////alert('redirect to Oregon...');
          //$('#state-select').modal('hide');
        //} else if ($.cookie("product_redirect") === 'XX') {
          ////alert('Redirecting to Other Place');
          //$('.notCA').removeClass('hidden');
          //$('#state-select').modal('hide');
        //}

        $.cookie("product_redirect", "OR", { expires: 7 });
        $('#state-select').modal('hide');

        // JavaScript to be fired on all pages
        if (!$('#nav').hasClass("scrolled")) {
          $(window).scroll(function() {
            if ($(document).scrollTop() > 50) {
              $('#nav').addClass('scrolled');
            } else {
              $('#nav').removeClass('scrolled');
            }
            if ($(document).scrollTop() > 621) {
              $('#calc-bar').addClass('navbar-fixed-top');
            } else {
              $('#calc-bar').removeClass('navbar-fixed-top');
            }
          });
        }

        window.overlay = function( show ) {
          $('#overlay').modal('toggle');
          if ( show ){
            $("#mailmsg").html("");
            $("#mail").show();
          }
          return false;
        };

        // sends Email
        window.liam = function() {
          var feed = $("#feed").val(),
              reserv_size = $("#reserv_size").val(),
              conductively = $("#conductively").val(),
              name = $("#fx45846342").val(),
              from = $("#fxsisliejlxfrm").val(),
              email = $("#fxisjleilsixto").val(),
              msg = $("#msg").val();

          if ( name.trim() === '' || from.trim() === '' || email.trim() === '' || msg.trim() === '' ){
            alert("Please complete all fields!");
            return false;
          }

          $.post(
            "/wp-content/themes/heavy/lib/custom/download.php",
            { feed:feed, reserv_size:reserv_size, conductively:conductively, name:name, from:from, email:email, msg:msg },
            function(data) {
              $("#mailmsg").html(data);
              $("#mail").hide();
            }
          );

          return false;
        };

        // Triggered on blur of email fields
        window.emailchk = function( getid ) {
          var email = $( '#'+getid ).val();
          var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          if ( email === '' )
            return true;
          if ( filter.test( email ) ) {
            // Yay! valid
              return true;
          } else {
            alert( 'Please provide a valid email address' );
            $( '#'+getid ).focus();
            return false;
          }
        };

        window.feed = function() {
          var feed = $("#feed").val(),
              reserv_size = $("#reserv_size").val();
          $.post("../wp-content/themes/heavy/lib/custom/doData.php", { feed: feed, reserv_size:reserv_size },
              function(data) {
              $("#data").html(data);
              conductively();
           });
        };

        window.conductively = function() {
          var feed = $("#feed").val(),
              conductively = $("#conductively").val();
          if (conductively !== "") {
            $.post("../wp-content/themes/heavy/lib/custom/doChart.php", {  feed: feed, conductively: conductively, uid: '<?php echo $uid;?>' },
              function(data) {
              $("#chart").html(data);
              //alert("Data Loaded: " + data);
             });
          } else if (conductively ==="") {
            $("#containerchart").html("");
            //$("#chart").html("");
          }
          if (feed === "") {
            $("#containerchart").html("");
          }
        };

        window.feed2 = function() {
          var feed = $("#feed").val(),
              reserv_size = $("#reserv_size").val();
          $.post("../wp-content/themes/heavy/lib/custom/chart-calc-foliar.php", { feed: feed, reserv_size:reserv_size },
              function(data) {
              $("#data").html(data);
              conductively();
           });
        };

        window.conductively2 = function() {
          var feed = $("#feed").val(),
              conductively = $("#conductively").val();
          if ( conductively !== "" ) {
            $.post("../wp-content/themes/heavy/lib/custom/chart-calc-foliar.php", {  feed: feed, conductively: conductively, uid: '<?php echo $uid;?>' },
              function(data) {
              $("#chart").html(data);
              //alert("Data Loaded: " + data);
             });
          } else if (conductively === "") {
            $( "#containerchart" ).html("");
            //$("#chart").html("");
          }
          if (feed === "") {
            $("#containerchart").html("");
          }
        };

        $('#sbi_images').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          slide: '.sbi_item'
        });

        $('#home-instagram #sb_instagram').smoothDivScroll({
          // mousewheelScrolling: "allDirections",
          manualContinuousScrolling: true,
          autoScrollingMode: "onStart",
          hotSpotScrollingInterval: 45,
          mousewheelScrolling: "",
          touchScrolling: true
        });

        $('#instagram-wrap #sb_instagram').smoothDivScroll({
          // mousewheelScrolling: "allDirections",
          manualContinuousScrolling: false,
          autoScrollingMode: "onStart",
          hotSpotScrollingInterval: 45,
          mousewheelScrolling: "",
          touchScrolling: true
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },

    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('#product-carousel').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          slide: '.item',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    // About us page, note the change from about-us to about_us.
    'foliar_calculator': {
      init: function() {

        feed2();
        conductively2();

      }
    },

    'nutrient_calculator': {
      init: function() {

        feed();
        conductively();

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

jQuery(document).ready(function( $ ) {

  var MediaPageDropdown = function(){
    var dropdownClass = '.dropdown-menu';
    if ($('.dropdown').hasClass('tabs-style')) {
      dropdownClass = '.dropdown-tabs';
    }
    var aria_labelledby = $('.dropdown').find(dropdownClass).attr('aria-labelledby');

    var selected_option = $(dropdownClass).find('.active').children('a').text();
    var html = '<a class="btn btn-default dropdown-toggle" id="' + aria_labelledby + '" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" >' + selected_option + '<i class="fa fa-angle-down"></i></a>';

    $('.dropdown').prepend( html );
  };

  MediaPageDropdown();

  $('.dropdown li a').on( 'click', function( event ){
    event.preventDefault();
    var selected_option = $(this).text();
    $(this).closest( '.dropdown' ).find( 'a.dropdown-toggle' ).html( selected_option + '<i class="fa fa-angle-down"></i>' );
  });

  $('#dropdown-feed li a').on( 'click', function( event ){
    var selected_value = $(this).data('value');
    // console.log ($(this).closest( '.dropdown' ));
    $(this).closest( '.dropdown' ).find( 'input' ).val(selected_value);
    feed();
  });

});
